import React from 'react';
import PropTypes from 'prop-types';
import BasicDataPod from '../BasicDataPod';
import ToggleDataPod from '../ToggleDataPod';
import Link from '../BasicDataPod/Link';
import Value from '../BasicDataPod/Value';
import Description from '../BasicDataPod/Description';
import './styles.css';

export default function PercentageDataPod({ content, isToggle, ...rest }) {
  const { values, text, linkText, linkUrl, subtitle } = content;
  return isToggle ? (
    <ToggleDataPod {...rest} content={content} type="percent" />
  ) : (
    <BasicDataPod {...rest}>
      <div className="percent-pod-value-container">
        <Value value={values[0].value} type="percent" />
        {subtitle ? <h5 className="percentage-data-pod-subtitle">{subtitle}</h5> : null}
      </div>
      <Description text={text} />
      <Link linkText={linkText} linkUrl={linkUrl} />
    </BasicDataPod>
  );
}

PercentageDataPod.propTypes = {
  header: PropTypes.string,
  tooltip: PropTypes.any,
  tooltipHeader: PropTypes.string,
  CustomTooltipIcon: PropTypes.object,
  footer: PropTypes.string,
  isToggle: PropTypes.bool,
  content: PropTypes.shape({
    values: PropTypes.array,
    text: PropTypes.string,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string,
  }),
};
